$ ->
  $('#calendar_date').datetimepicker({
    format: 'MMM YYYY'
  }).on('dp.change', (e)->
    $(document).find('#spinner, #overlay').show()
    $("#calendar_form").submit()
  )
